import React from 'react';

export const getSharedTimelinesTooltip = (access?: any): React.ReactNode => {
  if (!access) return '';

  const names = Array.isArray(access.shared_reference_timeline_names)
    ? access.shared_reference_timeline_names
    : [];

  return (
    <div>
      <div>
        Shared timelines: {Number(access.shared_reference_timeline_count || 0)}/
        {Number(access.reference_timeline_count || 0)}
      </div>
      {names.map((name: string, index: number) => (
        <div key={`${name}-${index}`}>- {name}</div>
      ))}
    </div>
  );
};
